import { render, staticRenderFns } from "./resource-upload-list.vue?vue&type=template&id=78d97ba9"
import script from "./resource-upload-list.vue?vue&type=script&lang=js"
export * from "./resource-upload-list.vue?vue&type=script&lang=js"
import style0 from "./resource-upload-list.vue?vue&type=style&index=0&id=78d97ba9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports